import { IAugmentedJQuery, element } from "angular";
import { IQuery } from "../../../../server/query";
import { SubFilter, SubFilterScope } from "./subFilters";

type nullOptions = "null" | "not null" | null;

export class NullFilter extends SubFilter {
  filterModel: nullOptions = null;

  readonly options: { display: string; value: nullOptions }[] = [
    {
      display: "Is Empty",
      value: "null",
    },
    {
      display: "Is Not Empty",
      value: "not null",
    },
  ];

  getGui(): IAugmentedJQuery {
    return element(`<select 
      title="${this.queryFieldNames[0]}-options-filter" 
      class="form-control" 
      ng-model="subFilterController.filterModel"
      ng-model-options="gridFilterController.defaultModelOptions"
      ng-change="subFilterController.filterModelChanged(subFilterController.filterModel)"
      ng-options="option.value as option.display for option in subFilterController.options track by option.value">
      <option value="">All</option>      
    </select>
    `);
  }

  beforeActivate(params: { $scope: SubFilterScope }) {
    super.beforeActivate(params);

    const queryObject = this.gridFilter?.getQueryObject();
    if (!queryObject) {
      return;
    }

    const nullOption = this.getNullOptionFromQueryObject(queryObject);
    const option = this.options.find((o) => o.value === nullOption);
    this.filterModel = option?.value ?? null;
  }
  getNullOptionFromQueryObject(queryObject: IQuery): nullOptions {
    const isNullQueryField = this.queryFieldNames[0];
    const isNotNullQueryField = this.queryFieldNames[1];

    if (queryObject[isNullQueryField]) {
      return "null";
    }
    if (queryObject[isNotNullQueryField]) {
      return "not null";
    }
    return null;
  }

  filterModelChanged(nullOption: nullOptions) {
    const queryModel = this.gridFilter?.getQueryObject() ?? {};
    const isNullQueryField = this.queryFieldNames[0];
    const isNotNullQueryField = this.queryFieldNames[1];

    switch (nullOption) {
      case null:
        delete queryModel[isNullQueryField];
        delete queryModel[isNotNullQueryField];
        break;
      case "not null":
        delete queryModel[isNullQueryField];
        queryModel[isNotNullQueryField] = true;
        break;
      case "null":
        queryModel[isNullQueryField] = true;
        delete queryModel[isNotNullQueryField];
        break;
    }
  }
}
